import React, { useState } from 'react';
import { Box, Container, Typography, Card, Tabs, Tab } from '@mui/material';
import { API_CONFIG, API_ENDPOINTS } from '../../config';

const CodeExamplesSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const apiUrl = `${API_CONFIG.BASE_URL}${API_ENDPOINTS.CAPTURE_SCREENSHOT}`;

  return (
    <Container maxWidth="lg" sx={{ py: 10 }}>
      <Typography variant="h3" align="center" gutterBottom sx={{ mb: 2 }}>
        Simple Integration
      </Typography>
      <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 6 }}>
        Get started in minutes with your favorite language
      </Typography>

      <Card>
        <Tabs 
          value={activeTab} 
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="JavaScript" />
          <Tab label="Python" />
          <Tab label="PHP" />
          <Tab label="Go" />
          <Tab label="cURL" />
        </Tabs>
        
        <Box sx={{ p: 0 }}>
          {activeTab === 0 && (
            <Box sx={{ bgcolor: '#1e1e1e', color: '#d4d4d4', p: 4, overflow: 'auto' }}>
              <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '0.9rem' }}>
{`const axios = require('axios');

const captureScreenshot = async () => {
  const response = await axios.post(
    '${apiUrl}',
    {
      url: 'https://example.com',
      viewport: { width: 1920, height: 1080 },
      format: 'png'
    },
    {
      headers: {
        'Authorization': 'Bearer YOUR_API_KEY',
        'Content-Type': 'application/json'
      }
    }
  );
  
  console.log(response.data.screenshot_url);
};

captureScreenshot();`}
              </pre>
            </Box>
          )}

          {activeTab === 1 && (
            <Box sx={{ bgcolor: '#1e1e1e', color: '#d4d4d4', p: 4, overflow: 'auto' }}>
              <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '0.9rem' }}>
{`import requests

def capture_screenshot():
    response = requests.post(
        '${apiUrl}',
        json={
            'url': 'https://example.com',
            'viewport': {'width': 1920, 'height': 1080},
            'format': 'png'
        },
        headers={
            'Authorization': 'Bearer YOUR_API_KEY',
            'Content-Type': 'application/json'
        }
    )
    
    if response.status_code == 200:
        print(response.json()['screenshot_url'])

capture_screenshot()`}
              </pre>
            </Box>
          )}

          {activeTab === 2 && (
            <Box sx={{ bgcolor: '#1e1e1e', color: '#d4d4d4', p: 4, overflow: 'auto' }}>
              <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '0.9rem' }}>
{`<?php
$apiKey = 'YOUR_API_KEY';
$url = '${apiUrl}';

$data = [
    'url' => 'https://example.com',
    'viewport' => ['width' => 1920, 'height' => 1080],
    'format' => 'png'
];

$options = [
    'http' => [
        'header' => [
            "Authorization: Bearer $apiKey",
            "Content-Type: application/json"
        ],
        'method' => 'POST',
        'content' => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result);

echo $response->screenshot_url;
?>`}
              </pre>
            </Box>
          )}

          {activeTab === 3 && (
            <Box sx={{ bgcolor: '#1e1e1e', color: '#d4d4d4', p: 4, overflow: 'auto' }}>
              <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '0.9rem' }}>
{`package main

import (
    "bytes"
    "encoding/json"
    "fmt"
    "net/http"
)

func captureScreenshot() {
    data := map[string]interface{}{
        "url": "https://example.com",
        "viewport": map[string]int{
            "width":  1920,
            "height": 1080,
        },
        "format": "png",
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", 
        "${apiUrl}",
        bytes.NewBuffer(jsonData))
    
    req.Header.Set("Authorization", "Bearer YOUR_API_KEY")
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    var result map[string]interface{}
    json.NewDecoder(resp.Body).Decode(&result)
    
    fmt.Println(result["screenshot_url"])
}

func main() {
    captureScreenshot()
}`}
              </pre>
            </Box>
          )}

          {activeTab === 4 && (
            <Box sx={{ bgcolor: '#1e1e1e', color: '#d4d4d4', p: 4, overflow: 'auto' }}>
              <pre style={{ margin: 0, fontFamily: 'monospace', fontSize: '0.9rem' }}>
{`curl -X POST ${apiUrl} \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "url": "https://example.com",
    "viewport": {
      "width": 1920,
      "height": 1080
    },
    "format": "png"
  }'`}
              </pre>
            </Box>
          )}
        </Box>
      </Card>
    </Container>
  );
};

export default CodeExamplesSection;

